import React, { useState, useEffect } from 'react';
import ImageUploader from '../ImageUploader';
import { auth, db, storage } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { ref, uploadString, getDownloadURL } from "firebase/storage";
import {
  disablePushNotifications,
  enablePushNotifications,
  getNotificationPermissionState,
} from '../../services/notificationService';


import bg1 from '../../assets/avatar/avatar-bg1.png';
import bg2 from '../../assets/avatar/avatar-bg2.png';
import bg3 from '../../assets/avatar/avatar-bg3.png';
import bg4 from '../../assets/avatar/avatar-bg4.png';
import bg5 from '../../assets/avatar/avatar-bg5.png';
import bg6 from '../../assets/avatar/avatar-bg6.png';

// Personaggi maschili (9)
import male1 from '../../assets/avatar/avatar-male1.png';
import male2 from '../../assets/avatar/avatar-male2.png';
import male3 from '../../assets/avatar/avatar-male3.png';
import male4 from '../../assets/avatar/avatar-male4.png';
import male5 from '../../assets/avatar/avatar-male5.png';
import male6 from '../../assets/avatar/avatar-male6.png';
import male7 from '../../assets/avatar/avatar-male7.png';
import male8 from '../../assets/avatar/avatar-male8.png';
import male9 from '../../assets/avatar/avatar-male9.png';

// Personaggi femminili (7)
import female1 from '../../assets/avatar/avatar-female1.png';
import female2 from '../../assets/avatar/avatar-female2.png';
import female3 from '../../assets/avatar/avatar-female3.png';
import female4 from '../../assets/avatar/avatar-female4.png';
import female5 from '../../assets/avatar/avatar-female5.png';
import female6 from '../../assets/avatar/avatar-female6.png';
import female7 from '../../assets/avatar/avatar-female7.png';


function EditProfileForm({ formData, setFormData, setEditProfile, handleSaveProfile }) {
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [notificationsEnabled, setNotificationsEnabled] = useState(formData.notificationsEnabled || false);
  const [notificationsSaving, setNotificationsSaving] = useState(false);

  // Stati per la modale avatar

  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [selectedBg, setSelectedBg] = useState(null);
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const [previewDataUrl, setPreviewDataUrl] = useState(null);
  const [combining, setCombining] = useState(false);

  const [avatarBase64, setAvatarBase64] = useState(null);
  const [avatarModified, setAvatarModified] = useState(false);


  // Genera anteprima live quando cambiano selezione
  useEffect(() => {
    if (selectedBg && selectedCharacter) {
      combineImages(selectedBg, selectedCharacter, (dataUrl) => {
        setPreviewDataUrl(dataUrl);
      });
    } else {
      setPreviewDataUrl(null);
    }
  }, [selectedBg, selectedCharacter]);

  // Combinazione di due immagini su canvas
  const combineImages = (bgUrl, charUrl, callback) => {
    setCombining(true);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const bgImg = new Image();
    const charImg = new Image();
    let loaded = 0;

    const checkDone = () => {
      if (loaded === 2) {
        canvas.width = bgImg.width;
        canvas.height = bgImg.height;
        ctx.drawImage(bgImg, 0, 0);
        ctx.drawImage(charImg, 0, 0);
        callback(canvas.toDataURL('image/png'));
        setCombining(false);
      }
    };

    bgImg.onload = () => { loaded++; checkDone(); };
    charImg.onload = () => { loaded++; checkDone(); };

    bgImg.src = bgUrl;
    charImg.src = charUrl;
  };
  const backgrounds = [bg1, bg2, bg3, bg4, bg5, bg6];
  const characters = [male1, male2, male3, male4, male5, male6, male7, male8, male9, female1, female2, female3, female4, female5, female6, female7,];
  const trimmedUsername = formData.username.trim();
  const isUsernameValid = trimmedUsername.length >= 3;
  const profileStatusClassName = saving
    ? 'profile-edit-status profile-edit-status--info'
    : hasChanges
      ? 'profile-edit-status profile-edit-status--warning'
      : 'profile-edit-status profile-edit-status--success';
  const profileStatusLabel = saving
    ? 'Salvataggio in corso'
    : hasChanges
      ? 'Hai modifiche da salvare'
      : 'Profilo sincronizzato';

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setHasChanges(true);
  };

  // Applica la combinazione come immagine profilo
  const applyAvatar = () => {
    if (!previewDataUrl) return;
    setAvatarBase64(previewDataUrl);
    setAvatarModified(true);
    setFormData(prev => ({ ...prev, profileImageUrl: previewDataUrl }));
    setHasChanges(true);
    setShowAvatarModal(false);
  };

  // NUOVO gestore per il caricamento normale (resetta l'avatar combinato)
  const handleImageUpload = (url) => {
    handleChange('profileImageUrl', url);
    setAvatarModified(false);
    setAvatarBase64(null);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      let finalProfileImageUrl = formData.profileImageUrl;

      if (avatarModified && avatarBase64) {
        const user = auth.currentUser;
        if (!user) throw new Error('Utente non autenticato');
        const storageRef = ref(storage, `user-propic/${user.uid}/avatar_${Date.now()}.png`);
        const base64Data = avatarBase64.split(',')[1] || avatarBase64;
        await uploadString(storageRef, base64Data, 'base64', { contentType: 'image/png' });
        const downloadUrl = await getDownloadURL(storageRef);
        finalProfileImageUrl = downloadUrl;
        setFormData(prev => ({ ...prev, profileImageUrl: downloadUrl }));
        setAvatarModified(false);
        setAvatarBase64(null);
      }

      // Usa la prop passata dal genitore
      await handleSaveProfile({ ...formData, profileImageUrl: finalProfileImageUrl });
      setHasChanges(false);
    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
      alert('Errore durante il salvataggio del profilo');
    } finally {
      setSaving(false);
    }
  };

  const handleNotificationToggle = async () => {
    setNotificationsSaving(true);

    try {
      if (!notificationsEnabled) {
        const result = await enablePushNotifications();
        if (!result.enabled) {
          alert('Permesso per le notifiche non concesso.');
          return;
        }

        setNotificationsEnabled(true);
        setFormData(prev => ({ ...prev, notificationsEnabled: true }));
        return;
      }

      await disablePushNotifications();
      setNotificationsEnabled(false);
      setFormData(prev => ({ ...prev, notificationsEnabled: false }));
    } catch (error) {
      const actionLabel = notificationsEnabled ? 'disattivazione' : 'attivazione';
      console.error(`Errore ${actionLabel} notifiche:`, error);
      alert(error.message || `Errore durante la ${actionLabel} delle notifiche.`);
    } finally {
      setNotificationsSaving(false);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;
      try {
        const docRef = doc(db, "users", user.uid);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          setFormData(prev => ({
            ...prev,
            notificationsEnabled: data.notificationsEnabled || false,
            fcmToken: data.fcmToken || null
          }));
          setNotificationsEnabled(data.notificationsEnabled || false);
        }
      } catch (error) {
        console.error("Errore nel caricamento utente:", error);
      }
    };

    fetchUserData();
  }, [setFormData]);

  return (
    <div className="card shadow-sm profile-edit-card">

      <div className="card-body p-2">
        <div className="mb-2 profile-edit-hero">

          <div className="profile-edit-hero__media">
            <ImageUploader
              onUploadSuccess={handleImageUpload}
              currentImageUrl={formData.profileImageUrl}
              label=""
              storagePath="user-propic"
              buttonText={
                <span>
                  <i className="bi bi-cloud-arrow-up me-2"></i>
                  {formData.profileImageUrl ? "Cambia Avatar" : "Carica Avatar"}
                </span>
              }
              buttonClass="btn btn-brand profile-edit-upload-btn"
              previewClass="profile-edit-avatar-preview"
              previewStyle={{
                width: '132px',
                height: '132px',
                objectFit: 'cover'
              }}
              infoText="Formati supportati: JPG, PNG. Max 2MB"
              showPreview={true}
            />
            <div className="profile-edit-avatar-note">
              Formati supportati: JPG, PNG. Max 2MB
            </div>
            <button
              className="btn btn-brand-secondary profile-edit-avatar-btn"
              onClick={() => setShowAvatarModal(true)}
            >
              <i className="bi bi-people-fill me-2"></i>
              Crea il tuo avatar
            </button>
          </div>

          {showAvatarModal && (
            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content border-0 shadow-lg rounded-4">
                  <div className="modal-header bg-brand-primary text-white border-0 rounded-top-4">
                    <h5 className="modal-title fw-semibold">
                      <i className="bi bi-images me-2"></i>
                      Personalizza il tuo avatar
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setShowAvatarModal(false)}
                      aria-label="Chiudi"
                    />
                  </div>

                  <div className="modal-body p-4">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="h-100 border-0 shadow-sm rounded-3">
                          <div className="card-body">
                            <h6 className="fw-semibold mb-3 text-brand-secondary">
                              <i className="bi bi-brush me-2"></i>
                              Sfondi
                            </h6>
                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                              {backgrounds.map((bg, idx) => (
                                <div
                                  key={idx}
                                  className={`avatar-option ${selectedBg === bg ? 'active' : ''}`}
                                  onClick={() => setSelectedBg(bg)}
                                >
                                  <img
                                    src={bg}
                                    alt={`Sfondo ${idx + 1}`}
                                    className="rounded-3"
                                    style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                                  />
                                  {selectedBg === bg && (
                                    <i className="bi bi-check-circle-fill position-absolute top-0 end-0 text-brand-secondary" style={{ fontSize: '1.2rem', transform: 'translate(25%, -25%)' }}></i>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="h-100 border-0 shadow-sm rounded-3">
                          <div className="card-body">
                            <h6 className="fw-semibold mb-3 text-brand-secondary">
                              <i className="bi bi-person-badge me-2"></i>
                              Personaggi
                            </h6>
                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                              {characters.map((ch, idx) => (
                                <div
                                  key={idx}
                                  className={`avatar-option ${selectedCharacter === ch ? 'active' : ''}`}
                                  onClick={() => setSelectedCharacter(ch)}
                                >
                                  <img
                                    src={ch}
                                    alt={`Personaggio ${idx + 1}`}
                                    className="rounded-3"
                                    style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                                  />
                                  {selectedCharacter === ch && (
                                    <i className="bi bi-check-circle-fill position-absolute top-0 end-0 text-brand-secondary" style={{ fontSize: '1.2rem', transform: 'translate(25%, -25%)' }}></i>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {selectedBg && selectedCharacter && (
                      <div className="text-center mt-4 pt-2">
                        <div className="border-0 shadow-sm rounded-3 p-3">
                          <h6 className="fw-semibold mb-3 text-brand-secondary">Anteprima avatar</h6>
                          {combining ? (
                            <div className="d-flex justify-content-center">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Combinazione in corso...</span>
                              </div>
                            </div>
                          ) : (
                            previewDataUrl && (
                              <img
                                src={previewDataUrl}
                                alt="Avatar combinato"
                                className="rounded-circle border border-3 border-white shadow"
                                style={{ width: '120px', height: '120px', objectFit: 'cover', margin: '0 auto' }}
                              />
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="modal-footer bg-light border-0 rounded-bottom-4 roster-form-actions">
                    <button
                      type="button"
                      className="btn roster-form-btn roster-form-btn--secondary"
                      onClick={() => setShowAvatarModal(false)}
                    >
                      <i className="bi bi-x-lg me-2"></i>
                      Annulla
                    </button>
                    <button
                      type="button"
                      className="btn btn-brand-secondary roster-form-btn roster-form-btn--primary"
                      onClick={applyAvatar}
                      disabled={!previewDataUrl}
                    >
                      <i className="bi bi-check-lg me-2"></i>
                      Applica avatar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="profile-edit-details-stack">
          <section className="profile-edit-surface">
            <div className="profile-edit-surface__head">
              <div>
                <h4 className="profile-edit-surface__title mb-2">
                  Dati del profilo
                </h4>
              </div>
            </div>

            <div className="row g-4 mt-1">
              <div className="col-12 col-lg-6">
                <label className="form-label profile-edit-label">
                  <i className="bi bi-person-fill me-2"></i>
                  Username
                </label>
                <input
                  type="text"
                  className={`form-control profile-edit-input ${isUsernameValid ? 'is-valid' : 'is-invalid'}`}
                  value={formData.username}
                  onChange={e => handleChange('username', e.target.value)}
                  placeholder="Il tuo username"
                  minLength="3"
                  required
                />
                <div className="text-muted-brand small profile-edit-helper">
                  Minimo 3 caratteri. Scegli un nome semplice da riconoscere nelle card e nelle classifiche.
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <label className="form-label profile-edit-label">
                  <i className="bi bi-envelope-fill me-2"></i>
                  Email
                </label>
                <input
                  type="email"
                  className="form-control profile-edit-input profile-edit-input--readonly"
                  value={formData.email}
                  disabled
                  readOnly
                />
                <div className="text-muted-brand small profile-edit-helper">
                  Contatta il team FantaWrestling se desideri aggiornare il tuo indirizzo email.
                </div>
              </div>
            </div>

            <div className="mt-4">
              <label
                className={`profile-notification-toggle ${
                  notificationsEnabled ? 'is-active' : 'is-inactive'
                } ${notificationsSaving ? 'is-loading' : ''}`}
                htmlFor="profile-notifications-toggle"
              >
                <span className="profile-notification-toggle__icon" aria-hidden="true">
                  <i className={`bi ${notificationsEnabled ? 'bi-bell-fill' : 'bi-bell-slash-fill'}`}></i>
                </span>

                <span className="profile-notification-toggle__copy">
                  <strong>
                    {notificationsSaving
                      ? 'Aggiornamento notifiche...'
                      : notificationsEnabled
                        ? 'Notifiche attive'
                        : 'Notifiche disattivate'}
                  </strong>
                  <small>
                    Ricevi news, risultati e aggiornamenti direttamente sul dispositivo.
                  </small>
                  <small className="profile-notification-toggle__status">
                    Stato browser: {getNotificationPermissionState() === 'granted'
                      ? 'consentite'
                      : getNotificationPermissionState() === 'denied'
                        ? 'bloccate dal browser'
                        : 'da autorizzare'}
                  </small>
                </span>

                <span className="profile-notification-toggle__switch" aria-hidden="true">
                  <span className="profile-notification-toggle__thumb"></span>
                </span>

                <input
                  className="profile-notification-toggle__input"
                  type="checkbox"
                  role="switch"
                  id="profile-notifications-toggle"
                  checked={notificationsEnabled}
                  onChange={handleNotificationToggle}
                  disabled={notificationsSaving}
                />
              </label>
            </div>
          </section>
        </div>

        <div className="mt-5 pt-4 profile-edit-actions roster-form-actions">

          <div className="profile-edit-actions__group roster-form-actions__group">
          <button
            type="button"
            className="btn roster-form-btn roster-form-btn--danger profile-edit-delete-btn"
            onClick={() => setShowDeleteConfirm(true)}
            title="Elimina account"
          >
            <i className="bi bi-trash me-2"></i>
            Elimina account
          </button>
            <button
              type="button"
              className="btn roster-form-btn roster-form-btn--secondary"
              onClick={() => setEditProfile(false)}
              disabled={saving}
            >
              <i className="bi bi-x-lg me-1"></i>
              Annulla
            </button>
            <button
              type="button"
              className="btn btn-brand-secondary roster-form-btn roster-form-btn--primary"
              onClick={handleSave}
              disabled={!isUsernameValid || saving || !hasChanges}
            >
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1"></span>
                  Salvataggio...
                </>
              ) : (
                <>
                  <i className="bi bi-check-lg me-1"></i>
                  Salva
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Modale Eliminazione Account */}
      {showDeleteConfirm && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  Elimina Account
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowDeleteConfirm(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="alert alert-danger">
                  <h6 className="alert-heading">Attenzione!</h6>
                  <p className="mb-0">Questa azione è permanente e non può essere annullata.</p>
                </div>

                <p className="mb-3">Verrano eliminati:</p>
                <ul className="small mb-3">
                  <li>Fazioni create</li>
                  <li>Impostazioni personali</li>
                  <li>Storico attività</li>
                </ul>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="confirmAccountDelete"
                  />
                  <label className="form-check-label" htmlFor="confirmAccountDelete">
                    Confermo di voler eliminare il mio account
                  </label>
                </div>
              </div>

              <div className="modal-footer roster-form-actions">
                <button
                  type="button"
                  className="btn roster-form-btn roster-form-btn--secondary"
                  onClick={() => setShowDeleteConfirm(false)}
                >
                  Annulla
                </button>
                <button
                  type="button"
                  className="btn roster-form-btn roster-form-btn--danger"
                  disabled
                >
                  <i className="bi bi-trash3-fill me-2"></i>
                  Elimina
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditProfileForm;
